import { render, staticRenderFns } from "./_shared.html?vue&type=template&id=6525326a&"
import script from "./Combustiveis.vue?vue&type=script&lang=js&"
export * from "./Combustiveis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports